import React, { useState } from 'react';
import { Button, Modal, Row, Col, Select } from '@pankod/refine-antd';

interface CustomTimePickerProps {
  value: string;
  onChange: (time: string) => void;
  placeholder?: string;
}

export const CustomTimePicker: React.FC<CustomTimePickerProps> = ({
  value,
  onChange,
  placeholder = "Seleccionar hora"
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedHour, setSelectedHour] = useState(value.split(':')[0] || '09');
  const [selectedMinute, setSelectedMinute] = useState(value.split(':')[1] || '00');

  // Generar opciones de horas (00-23)
  const hourOptions = Array.from({ length: 24 }, (_, i) => ({
    label: i.toString().padStart(2, '0'),
    value: i.toString().padStart(2, '0'),
  }));

  // Generar opciones de minutos (00, 15, 30, 45)
  const minuteOptions = [
    { label: '00', value: '00' },
    { label: '15', value: '15' },
    { label: '30', value: '30' },
    { label: '45', value: '45' },
  ];

  const handleOk = () => {
    const newTime = `${selectedHour}:${selectedMinute}`;
    onChange(newTime);
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    // Resetear a los valores actuales si se cancela
    setSelectedHour(value.split(':')[0] || '09');
    setSelectedMinute(value.split(':')[1] || '00');
    setIsModalVisible(false);
  };

  const showModal = () => {
    setSelectedHour(value.split(':')[0] || '09');
    setSelectedMinute(value.split(':')[1] || '00');
    setIsModalVisible(true);
  };

  return (
    <>
      <Button onClick={showModal} style={{ width: '100%', textAlign: 'left' }}>
        {value || placeholder}
      </Button>
      
      <Modal
        title="Seleccionar Hora"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Confirmar"
        cancelText="Cancelar"
        width={300}
      >
        <Row gutter={16} style={{ padding: '20px 0' }}>
          <Col span={12}>
            <div style={{ marginBottom: 8, fontWeight: 'bold' }}>Hora</div>
            <Select
              value={selectedHour}
              onChange={setSelectedHour}
              style={{ width: '100%' }}
              options={hourOptions}
              showSearch
            />
          </Col>
          <Col span={12}>
            <div style={{ marginBottom: 8, fontWeight: 'bold' }}>Minutos</div>
            <Select
              value={selectedMinute}
              onChange={setSelectedMinute}
              style={{ width: '100%' }}
              options={minuteOptions}
            />
          </Col>
        </Row>
        <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', marginTop: 20 }}>
          {selectedHour}:{selectedMinute}
        </div>
      </Modal>
    </>
  );
};
